import React from 'react';

import {ConfirmDeletionScreen} from 'features/auth';

const ConfirmDeletionPage: React.FC = () => {
    return <ConfirmDeletionScreen/>;
};

export default ConfirmDeletionPage;
